import React,{useEffect,useState} from 'react';
import { Clock, FileText, Brain, Network, Search, Users, Check, ArrowRight } from 'lucide-react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../services/axiosInstance';
import DOMPurify from 'dompurify';
import { useNavigate } from 'react-router-dom';


const CourseModuleLoader = () => (
  <div className="bg-white min-h-screen animate-pulse">
    <div className="mx-auto px-4 py-8">
      {/* Top Section */}
      <div className="flex flex-col lg:flex-row gap-8 items-start mb-12 bg-blue-50 p-8 rounded-lg">
        {/* Left Side */}
        <div className="flex-1">
          {/* Title */}
          <div className="h-6 bg-gray-200 rounded w-3/4 mb-4"></div>

          {/* Info Row */}
          <div className="flex items-center gap-6 mb-4">
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
              <div className="h-4 w-20 bg-gray-200 rounded"></div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
              <div className="h-4 w-20 bg-gray-200 rounded"></div>
            </div>
          </div>

          {/* Progress Bar */}
          <div className="w-full max-w-md mb-6">
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div className="bg-gray-300 h-2 rounded-full w-1/2"></div>
            </div>
          </div>
        </div>

        {/* Right Side Image */}
        <div className="lg:w-96 lg:h-64 bg-gray-200 rounded-lg"></div>
      </div>

      {/* Content Skeleton */}
      <div className="space-y-4 mb-12">
        <div className="h-4 bg-gray-200 rounded w-11/12"></div>
        <div className="h-4 bg-gray-200 rounded w-10/12"></div>
        <div className="h-4 bg-gray-200 rounded w-9/12"></div>
        <div className="h-4 bg-gray-200 rounded w-8/12"></div>
        <div className="h-4 bg-gray-200 rounded w-7/12"></div>
      </div>

      {/* Button Skeleton */}
      <div className="flex justify-center">
        <div className="h-10 w-40 bg-gray-300 rounded-lg"></div>
      </div>
    </div>
  </div>
  );



function CourseModule() {
  const { id } = useParams();
  const handleStartQuiz = () => {
    navigate(`/nurse/assement/${id}`);
  };
  
  const getModuleData = (moduleId) => {
    const moduleData = {
      1: {
        title: "ADHD Fundamentals & Neurobiology",
        duration: "30 minutes",
        moduleNumber: "1 of 8"
      },
      2: {
        title: "Assessment & Diagnosis",
        duration: "25 minutes",
        moduleNumber: "2 of 8"
      },
      3: {
        title: "Treatment Strategies",
        duration: "35 minutes",
        moduleNumber: "3 of 8"
      },
      4: {
        title: "Patient Communication",
        duration: "20 minutes",
        moduleNumber: "4 of 8"
      },
      5: {
        title: "Ongoing Care Management",
        duration: "30 minutes",
        moduleNumber: "5 of 8"
      }
    };
    return moduleData[moduleId] || moduleData[1];
  };


  const [module,setModule] = useState({title:"",duration:""})
  const [isPageLoading,setIsPageLoading] = useState(true)
  const navigate = useNavigate();
  useEffect(() => {
    const fetchModule = async () => {
        try {
          const res = await axiosInstance.get(`/course/module/${id}`);
          setModule(res.data.data.module);
          setIsPageLoading(false)
        } catch (error) {
          console.error("Error fetching course:", error);
        }
      };
      fetchModule();
    }, []);


  const currentModule = getModuleData(1);
  const progressPercentage = Math.round((parseInt(id) / 8) * 100);
  return isPageLoading ? (
    <CourseModuleLoader />
  ) : (       
      <div className="bg-white min-h-screen">
        <div className=" mx-auto px-4 py-8">
          {/* Top Section - Header */}
          <div className="flex hidden flex-col lg:flex-row gap-8 items-start mb-12 bg-blue-50 p-8 rounded-lg">
            {/* Left Side - Module Info */}
            <div className="flex-1">
              <h1 className="text-2xl font-semibold text-gray-900 ">
                Module : {module.title} 
              </h1>
              <div className="flex items-center gap-6 mb-4">
                <div className="flex items-center gap-2 text-gray-600">
                  <Clock className="w-5 h-5" />
                  <span className="font-medium">{module.duration}</span>
                </div>
                <div className="flex items-center gap-2 text-gray-600">
                  <FileText className="w-5 h-5" />
                  <span className="font-medium">{currentModule.moduleNumber}</span>
                </div>
              </div>
              
              {/* Progress Bar */}
              <div className="w-full max-w-md mb-6">
                <div className="w-full bg-blue-100 rounded-full h-2">
                  <div 
                    className="bg-blue-500 h-2 rounded-full transition-all duration-300"
                    style={{ width: 80 }}
                  ></div>
                </div>
              </div>

            </div>
            
            {/* Right Side - Brain Image */}
          <div className="lg:w-96 lg:h-64 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden">
            <img
              src="/images/FRAME (38).png"
              alt="Brain & Neuron Models"
              className="w-full h-full object-cover"   // use object-contain if you don't want cropping
            />
          </div>
          </div>
          <>
          <h2 class="text-3xl md:text-4xl font-bold tracking-tight text-slate-900 mb-6">{module.title}</h2>
            <div className='w-full' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(module.content) }} />
          </>
          {
            <div className="mb-12">
                <div className="text-center pt-4">
                  <button 
                  onClick={handleStartQuiz}
                  className="bg-blue-500 hover:bg-blue-600 text-white font-medium px-8 py-3 rounded-lg transition-colors duration-200">
                  Start Test
                  </button>
                </div>
            </div>
          }
      </div>
      </div>);
}


export default CourseModule;